module.exports = __webpack_public_path__ + "static/media/doyou-have-account-img.f532bb79.png";